import React from "react";
import { Col, Container, Row } from "reactstrap";

// redux
import { useSelector, shallowEqual } from "react-redux";

// router
import { Link } from "react-router-dom";

const NotFound = () => {
  document.title = "Sayfa Bulunamadı | Metiner Avantaj+";

  const { authCheckLoading } = useSelector((state) => {
    return {
      authCheckLoading: state.auth.authCheckLoading,
    };
  }, shallowEqual);

  // kullanıcı giriş yapmış ise ana sayfaya yönlendirir.
  // useEffect(() => {
  //   const storedAuthUserString = localStorage.getItem("authUser");
  //   const authUserObject = JSON.parse(storedAuthUserString);
  //   const accessToken = authUserObject?.token;

  //   const authCheckFunc = async () => {
  //     try {
  //       await dispatch(authCheck()).unwrap();

  //       navigate("/dashboard");
  //     } catch (error) {}
  //   };

  //   if (accessToken) authCheckFunc();
  // }, []);

  if (authCheckLoading) {
    return (
      <div id="preloader">
        <div id="status">
          <div className="spinner-border text-primary avatar-xs" role="status">
            <span className="visually-hidden">Yükleniyor...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="auth-page-content" style={{ background: "white" }}>
        <div className="auth-page-wrapper py-5 d-flex justify-content-center align-items-center min-vh-100">
          <div className="auth-page-content overflow-hidden p-0">
            <Container>
              <Row className="justify-content-center">
                <Col xl={7} lg={8}>
                  <div className="text-center">
                    <img
                      src={process.env.PUBLIC_URL + "/images/common/404.svg"}
                      alt="page not found img"
                      className="img-fluid"
                    />
                    <div className="mt-3">
                      <Link to="/" className="btn btn-dark">
                        <i className="mdi mdi-home me-1"></i>Ana Sayfaya dön
                      </Link>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default NotFound;
